import { render, staticRenderFns } from "./SidebarMenuVueComponent.vue?vue&type=template&id=5e2d1894&"
import script from "./SidebarMenuVueComponent.vue?vue&type=script&lang=ts&"
export * from "./SidebarMenuVueComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarMenuVueComponent.vue?vue&type=style&index=0&id=5e2d1894&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports